import { Characteristic, ValueDefinition } from '../types';
export const ZBeidseitigSperrbar = (doorModel: string, lengthInside: number, lengthOutside: number): string => {
    let lltNumber: string = '0';

    switch (doorModel) {
        case 'BERT':
        case 'VERT':
            if (lengthOutside === 45 && lengthInside === 55) {
                lltNumber = 'LLT510001';
            } else if (lengthOutside === 45 && lengthInside === 65) {
                lltNumber = 'LLT510092';
            } else if (lengthOutside === 45 && lengthInside === 70) {
                lltNumber = 'LLT510038';
            } else if (lengthOutside === 50 && lengthInside === 50) {
                lltNumber = 'LLT510002'	;
            } else if (lengthOutside === 50 && lengthInside === 60) {
                lltNumber = 'LLT510093'	;
            } else if (lengthOutside === 50 && lengthInside === 65) {
                lltNumber = 'LLT510039'	;
            } else if (lengthOutside === 55 && lengthInside === 45) {
                lltNumber = 'LLT510004'	;
            } else if (lengthOutside === 55 && lengthInside === 55) {
                lltNumber = 'LLT510110'	;
            } else if (lengthOutside === 55 && lengthInside === 65) {
                lltNumber = 'LLT510074'	;
            } else if (lengthOutside === 60 && lengthInside === 40) {
                lltNumber = 'LLT510003'	;
            } else if (lengthOutside === 60 && lengthInside === 50) {
                lltNumber = 'LLT510111'	;
            } else if (lengthOutside === 60 && lengthInside === 50) {
                lltNumber = 'LLT510094'	;
            } else if (lengthOutside === 60 && lengthInside === 55) {
                lltNumber = 'LLT510095'	;
            } else if (lengthOutside === 60 && lengthInside === 55) {
                lltNumber = 'LLT510040'	;
            } else if (lengthOutside === 60 && lengthInside === 60) {
                lltNumber = 'LLT510041'	;
            } else if (lengthOutside === 60 && lengthInside === 60) {
                lltNumber = 'LLT510075'	;
            } else if (lengthOutside === 60 && lengthInside === 70) {
                lltNumber = 'LLT510020'	;
            } else if (lengthOutside === 65 && lengthInside === 45) {
                lltNumber = 'LLT510113'	;
            } else if (lengthOutside === 65 && lengthInside === 50) {
                lltNumber = 'LLT510057'	;
            } else if (lengthOutside === 65 && lengthInside === 55) {
                lltNumber = 'LLT510077'	;
            } else if (lengthOutside === 65 && lengthInside === 65) {
                lltNumber = 'LLT510021'	;
            } else if (lengthOutside === 70 && lengthInside === 40) {
                lltNumber = 'LLT510112'	;
            } else if (lengthOutside === 70 && lengthInside === 45) {
                lltNumber = 'LLT510059'	;
            } else if (lengthOutside === 70 && lengthInside === 50) {
                lltNumber = 'LLT510076'	;
            } else if (lengthOutside === 70 && lengthInside === 60) {
                lltNumber = 'LLT510023'	;
            } else if (lengthOutside === 75 && lengthInside === 40) {
                lltNumber = 'LLT510058'	;
            } else if (lengthOutside === 75 && lengthInside === 55) {
                lltNumber = 'LLT510022'	;
            }
            break;
        case 'CERT':
            if (lengthOutside === 30 && lengthInside === 40) {
                lltNumber = 'LLT510013';
            } else if (lengthOutside === 30 && lengthInside === 50) {
                lltNumber = 'LLT510104';
            } else if (lengthOutside === 30 && lengthInside === 55) {
                lltNumber = 'LLT510050';
            } else if (lengthOutside === 35 && lengthInside === 35) {
                lltNumber = 'LLT510014';
            } else if (lengthOutside === 35 && lengthInside === 45) {
                lltNumber = 'LLT510105';
            } else if (lengthOutside === 35 && lengthInside === 50) {
                lltNumber = 'LLT510051';
            } else if (lengthOutside === 40 && lengthInside === 40) {
                lltNumber = 'LLT510122';
            } else if (lengthOutside === 40 && lengthInside === 40) {
                lltNumber = 'LLT510124';
            } else if (lengthOutside === 40 && lengthInside === 50) {
                lltNumber = 'LLT510086';
            } else if (lengthOutside === 45 && lengthInside === 35) {
                lltNumber = 'LLT510123';
            } else if (lengthOutside === 45 && lengthInside === 35) {
                lltNumber = 'LLT510125';
            } else if (lengthOutside === 45 && lengthInside === 40) {
                lltNumber = 'LLT510068';
            } else if (lengthOutside === 45 && lengthInside === 45) {
                lltNumber = 'LLT510087';
            } else if (lengthOutside === 45 && lengthInside === 55) {
                lltNumber = 'LLT510032';
            } else if (lengthOutside === 50 && lengthInside === 35) {
                lltNumber = 'LLT510069';
            } else if (lengthOutside === 50 && lengthInside === 50) {
                lltNumber = 'LLT510033';
            }
            break;
    }

    return lltNumber;
};

export const ZMitKnauf = (doorModel: string, lengthInside: number, lengthOutside: number): string => {
    let lltNumber: string = '0';

    switch (doorModel) {
        case 'BERT':
        case 'VERT':
            if (lengthOutside === 45 && lengthInside === 55) {
                lltNumber = 'LLT510009';
            } else if (lengthOutside === 45 && lengthInside === 65) {
                lltNumber = 'LLT510100';
            } else if (lengthOutside === 45 && lengthInside === 70) {
                lltNumber = 'LLT510046';
            } else if (lengthOutside === 50 && lengthInside === 50) {
                lltNumber = 'LLT510010';
            } else if (lengthOutside === 50 && lengthInside === 60) {
                lltNumber = 'LLT510101';
            } else if (lengthOutside === 50 && lengthInside === 65) {
                lltNumber = 'LLT510047';
            } else if (lengthOutside === 55 && lengthInside === 45) {
                lltNumber = 'LLT510012';
            } else if (lengthOutside === 55 && lengthInside === 55) {
                lltNumber = 'LLT510118';
            } else if (lengthOutside === 55 && lengthInside === 65) {
                lltNumber = 'LLT510082';
            } else if (lengthOutside === 60 && lengthInside === 40) {
                lltNumber = 'LLT510011';
            } else if (lengthOutside === 60 && lengthInside === 50) {
                lltNumber = 'LLT510119';
            } else if (lengthOutside === 60 && lengthInside === 50) {
                lltNumber = 'LLT510102';
            } else if (lengthOutside === 60 && lengthInside === 55) {
                lltNumber = 'LLT510103';
            } else if (lengthOutside === 60 && lengthInside === 55) {
                lltNumber = 'LLT510056';
            } else if (lengthOutside === 60 && lengthInside === 55) {
                lltNumber = 'LLT510064';
            } else if (lengthOutside === 60 && lengthInside === 55) {
                lltNumber = 'LLT510048';
            } else if (lengthOutside === 60 && lengthInside === 60) {
                lltNumber = 'LLT510049';
            } else if (lengthOutside === 60 && lengthInside === 60) {
                lltNumber = 'LLT510083';
            } else if (lengthOutside === 60 && lengthInside === 70) {
                lltNumber = 'LLT510028';
            } else if (lengthOutside === 65 && lengthInside === 45) {
                lltNumber = 'LLT510121';
            } else if (lengthOutside === 65 && lengthInside === 50) {
                lltNumber = 'LLT510065';
            } else if (lengthOutside === 65 && lengthInside === 55) {
                lltNumber = 'LLT510085';
            } else if (lengthOutside === 65 && lengthInside === 65) {
                lltNumber = 'LLT510029';
            } else if (lengthOutside === 70 && lengthInside === 40) {
                lltNumber = 'LLT510120';
            } else if (lengthOutside === 70 && lengthInside === 45) {
                lltNumber = 'LLT510067';
            } else if (lengthOutside === 70 && lengthInside === 50) {
                lltNumber = 'LLT510084';
            } else if (lengthOutside === 70 && lengthInside === 60) {
                lltNumber = 'LLT510031';
            } else if (lengthOutside === 75 && lengthInside === 40) {
                lltNumber = 'LLT510066';
            } else if (lengthOutside === 75 && lengthInside === 55) {
                lltNumber = 'LLT510030';
            }
            break;
        case 'CERT':
            if (lengthOutside === 30 && lengthInside === 40) {
                lltNumber = 'LLT510017';
            } else if (lengthOutside === 30 && lengthInside === 50) {
                lltNumber = 'LLT510108';
            } else if (lengthOutside === 30 && lengthInside === 55) {
                lltNumber = 'LLT510054';
            } else if (lengthOutside === 35 && lengthInside === 35) {
                lltNumber = 'LLT510018';
            } else if (lengthOutside === 35 && lengthInside === 45) {
                lltNumber = 'LLT510109';
            } else if (lengthOutside === 35 && lengthInside === 50) {
                lltNumber = 'LLT510055';
            } else if (lengthOutside === 40 && lengthInside === 40) {
                lltNumber = 'LLT510128';
            } else if (lengthOutside === 40 && lengthInside === 50) {
                lltNumber = 'LLT510090';
            } else if (lengthOutside === 45 && lengthInside === 35) {
                lltNumber = 'LLT510129';
            } else if (lengthOutside === 45 && lengthInside === 40) {
                lltNumber = 'LLT510072';
            } else if (lengthOutside === 45 && lengthInside === 45) {
                lltNumber = 'LLT510091';
            } else if (lengthOutside === 45 && lengthInside === 55) {
                lltNumber = 'LLT510036';
            } else if (lengthOutside === 50 && lengthInside === 35) {
                lltNumber = 'LLT510073';
            } else if (lengthOutside === 50 && lengthInside === 50) {
                lltNumber = 'LLT510037';
            }
            break;
    }

    return lltNumber;
};

export const FZBeidseitigSperrbar = (doorModel: string, lengthInside: number, lengthOutside: number): string => {
    let lltNumber: string = '0';

    switch (doorModel) {
        case 'BERT':
        case 'VERT':
            if (lengthOutside === 45 && lengthInside === 55) {
                lltNumber = 'LLT510005'	;
            } else if (lengthOutside === 45 && lengthInside === 65) {
                lltNumber = 'LLT510096'	;
            } else if (lengthOutside === 45 && lengthInside === 70) {
                lltNumber = 'LLT510042'	;
            } else if (lengthOutside === 50 && lengthInside === 50) {
                lltNumber = 'LLT510006'	;
            } else if (lengthOutside === 50 && lengthInside === 60) {
                lltNumber = 'LLT510097'	;
            } else if (lengthOutside === 50 && lengthInside === 65) {
                lltNumber = 'LLT510043'	;
            } else if (lengthOutside === 55 && lengthInside === 45) {
                lltNumber = 'LLT510008'	;
            } else if (lengthOutside === 55 && lengthInside === 55) {
                lltNumber = 'LLT510114'	;
            } else if (lengthOutside === 60 && lengthInside === 40) {
                lltNumber = 'LLT510007'	;
            } else if (lengthOutside === 60 && lengthInside === 50) {
                lltNumber = 'LLT510115'	;
            } else if (lengthOutside === 60 && lengthInside === 50) {
                lltNumber = 'LLT510098'	;
            } else if (lengthOutside === 60 && lengthInside === 55) {
                lltNumber = 'LLT510099'	;
            } else if (lengthOutside === 60 && lengthInside === 55) {
                lltNumber = 'LLT510060'	;
            } else if (lengthOutside === 60 && lengthInside === 55) {
                lltNumber = 'LLT510044'	;
            } else if (lengthOutside === 60 && lengthInside === 60) {
                lltNumber = 'LLT510045'	;
            } else if (lengthOutside === 60 && lengthInside === 60) {
                lltNumber = 'LLT510079'	;
            } else if (lengthOutside === 65 && lengthInside === 45) {
                lltNumber = 'LLT510117'	;
            } else if (lengthOutside === 65 && lengthInside === 50) {
                lltNumber = 'LLT510061'	;
            } else if (lengthOutside === 65 && lengthInside === 55) {
                lltNumber = 'LLT510081'	;
            } else if (lengthOutside === 70 && lengthInside === 40) {
                lltNumber = 'LLT510116'	;
            } else if (lengthOutside === 70 && lengthInside === 45) {
                lltNumber = 'LLT510063'	;
            } else if (lengthOutside === 70 && lengthInside === 50) {
                lltNumber = 'LLT510080'	;
            } else if (lengthOutside === 75 && lengthInside === 40) {
                lltNumber = 'LLT510062'	;
            } else if (lengthOutside === 55 && lengthInside === 65) {
                lltNumber = 'LLT510078'	;
            } else if (lengthOutside === 60 && lengthInside === 70) {
                lltNumber = 'LLT510024'	;
            } else if (lengthOutside === 65 && lengthInside === 65) {
                lltNumber = 'LLT510025'	;
            } else if (lengthOutside === 70 && lengthInside === 60) {
                lltNumber = 'LLT510027'	;
            } else if (lengthOutside === 75 && lengthInside === 55) {
                lltNumber = 'LLT510026'	;
            }
            break;
        case 'CERT':
            if (lengthOutside === 35 && lengthInside === 35) {
                lltNumber = 'LLT510016';
            } else if (lengthOutside === 35 && lengthInside === 45) {
                lltNumber = 'LLT510107';
            } else if (lengthOutside === 35 && lengthInside === 50) {
                lltNumber = 'LLT510053';
            } else if (lengthOutside === 40 && lengthInside === 40) {
                lltNumber = 'LLT510126';
            } else if (lengthOutside === 40 && lengthInside === 50) {
                lltNumber = 'LLT510088';
            } else if (lengthOutside === 45 && lengthInside === 35) {
                lltNumber = 'LLT510127';
            } else if (lengthOutside === 45 && lengthInside === 40) {
                lltNumber = 'LLT510070';
            } else if (lengthOutside === 45 && lengthInside === 45) {
                lltNumber = 'LLT510089';
            } else if (lengthOutside === 45 && lengthInside === 55) {
                lltNumber = 'LLT510034';
            } else if (lengthOutside === 50 && lengthInside === 35) {
                lltNumber = 'LLT510071';
            } else if (lengthOutside === 50 && lengthInside === 50) {
                lltNumber = 'LLT510035';
            }
            break;
    }

    return lltNumber;
};

export const FZMitDrehrad = (doorModel: string, lengthInside: number, lengthOutside: number): string => {
    let lltNumber: string = '0';

    switch (doorModel) {
        case 'BERT':
        case 'VERT':
            if (lengthOutside === 45 && lengthInside === 55) {
                lltNumber = 'LLT510005';
            } else if (lengthOutside === 45 && lengthInside === 65) {
                lltNumber = 'LLT510096';
            } else if (lengthOutside === 45 && lengthInside === 70) {
                lltNumber = 'LLT510042';
            } else if (lengthOutside === 50 && lengthInside === 50) {
                lltNumber = 'LLT510006';
            } else if (lengthOutside === 50 && lengthInside === 60) {
                lltNumber = 'LLT510097';
            } else if (lengthOutside === 50 && lengthInside === 65) {
                lltNumber = 'LLT510043';
            } else if (lengthOutside === 55 && lengthInside === 45) {
                lltNumber = 'LLT510008';
            } else if (lengthOutside === 55 && lengthInside === 55) {
                lltNumber = 'LLT510114';
            } else if (lengthOutside === 60 && lengthInside === 40) {
                lltNumber = 'LLT510007';
            } else if (lengthOutside === 60 && lengthInside === 50) {
                lltNumber = 'LLT510115';
            } else if (lengthOutside === 60 && lengthInside === 50) {
                lltNumber = 'LLT510098';
            } else if (lengthOutside === 60 && lengthInside === 55) {
                lltNumber = 'LLT510099';
            } else if (lengthOutside === 60 && lengthInside === 55) {
                lltNumber = 'LLT510060';
            } else if (lengthOutside === 60 && lengthInside === 55) {
                lltNumber = 'LLT510044';
            } else if (lengthOutside === 60 && lengthInside === 60) {
                lltNumber = 'LLT510045';
            } else if (lengthOutside === 60 && lengthInside === 60) {
                lltNumber = 'LLT510079';
            } else if (lengthOutside === 65 && lengthInside === 45) {
                lltNumber = 'LLT510117';
            } else if (lengthOutside === 65 && lengthInside === 50) {
                lltNumber = 'LLT510061';
            } else if (lengthOutside === 65 && lengthInside === 55) {
                lltNumber = 'LLT510081';
            } else if (lengthOutside === 70 && lengthInside === 40) {
                lltNumber = 'LLT510116';
            } else if (lengthOutside === 70 && lengthInside === 45) {
                lltNumber = 'LLT510063';
            } else if (lengthOutside === 70 && lengthInside === 50) {
                lltNumber = 'LLT510080';
            } else if (lengthOutside === 75 && lengthInside === 40) {
                lltNumber = 'LLT510062';
            } else if (lengthOutside === 55 && lengthInside === 65) {
                lltNumber = 'LLT510078';
            } else if (lengthOutside === 60 && lengthInside === 70) {
                lltNumber = 'LLT510024';
            } else if (lengthOutside === 65 && lengthInside === 65) {
                lltNumber = 'LLT510025';
            } else if (lengthOutside === 70 && lengthInside === 60) {
                lltNumber = 'LLT510027';
            } else if (lengthOutside === 75 && lengthInside === 55) {
                lltNumber = 'LLT510026';
            }
            break;
        case 'CERT':
            if (lengthOutside === 35 && lengthInside === 35) {
                lltNumber = 'LLT510016';
            } else if (lengthOutside === 35 && lengthInside === 45) {
                lltNumber = 'LLT510107';
            } else if (lengthOutside === 35 && lengthInside === 50) {
                lltNumber = 'LLT510053';
            } else if (lengthOutside === 40 && lengthInside === 40) {
                lltNumber = 'LLT510126';
            } else if (lengthOutside === 40 && lengthInside === 50) {
                lltNumber = 'LLT510088';
            } else if (lengthOutside === 45 && lengthInside === 35) {
                lltNumber = 'LLT510127';
            } else if (lengthOutside === 45 && lengthInside === 40) {
                lltNumber = 'LLT510070';
            } else if (lengthOutside === 45 && lengthInside === 45) {
                lltNumber = 'LLT510089';
            } else if (lengthOutside === 45 && lengthInside === 55) {
                lltNumber = 'LLT510034';
            } else if (lengthOutside === 50 && lengthInside === 35) {
                lltNumber = 'LLT510071';
            } else if (lengthOutside === 50 && lengthInside === 50) {
                lltNumber = 'LLT510035';
            }
            break;
    }

    return lltNumber;
};